module.exports = __webpack_public_path__ + "static/media/icon_meal_active.a5d3224a.svg";